import { render } from "./Misconduct_RefCoach.vue?vue&type=template&id=31a09e0c&scoped=true"
import script from "./Misconduct_RefCoach.vue?vue&type=script&lang=js"
export * from "./Misconduct_RefCoach.vue?vue&type=script&lang=js"

import "./Misconduct_RefCoach.vue?vue&type=style&index=0&id=31a09e0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a09e0c"]])

export default __exports__